import { useEffect, useRef } from 'react';
import { api } from '@/lib/api';

const KEY = 'apex_last_alert_ts';

export default function NotificationWorker() {
  const permRef = useRef(typeof Notification !== 'undefined' ? Notification.permission : 'default');

  useEffect(() => {
    // Register service worker for web push + offline shell
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.register('/sw.js').then(async (reg) => {
        try {
          // If the browser supports PushManager and user granted permission,
          // upsert a local subscription record with the backend (no VAPID required for local tracking).
          if ('PushManager' in window && Notification.permission === 'granted') {
            const existing = await reg.pushManager.getSubscription();
            if (existing) {
              await api.post('/push/subscribe', {
                endpoint: existing.endpoint,
                keys: existing.toJSON().keys || {},
                user_agent: navigator.userAgent,
              }).catch(() => {});
            }
          }
        } catch (e) { /* ignore */ }
      }).catch(() => {});
    }

    if (typeof Notification === 'undefined') return;
    if (Notification.permission === 'default') {
      Notification.requestPermission().then((p) => (permRef.current = p));
    }
    const tick = async () => {
      try {
        const { data } = await api.get('/compliance/alerts-fired?limit=20');
        const last = localStorage.getItem(KEY);
        const fresh = data.alerts.filter((a) => !last || a.ts > last);
        if (fresh.length && permRef.current === 'granted') {
          fresh.slice(0, 4).forEach((a) => {
            try {
              const title = `APEXFLOW · ${a.rule_name}`;
              const body = (() => {
                const p = a.payload || {};
                if (p.usd_value) return `${p.symbol || ''} · $${Number(p.usd_value).toLocaleString()}`;
                if (p.notional) return `${p.symbol || ''} order notional $${Number(p.notional).toLocaleString()}`;
                if (p.action) return `${p.symbol || ''} ${p.action} · conf ${(p.confidence * 100).toFixed(0)}%`;
                return a.rule_type;
              })();
              new Notification(title, { body, icon: '/favicon.ico', tag: a.id });
            } catch (e) {}
          });
        }
        if (data.alerts[0]) localStorage.setItem(KEY, data.alerts[0].ts);
      } catch (e) {}
    };
    tick();
    const t = setInterval(tick, 8000);
    return () => clearInterval(t);
  }, []);

  return null;
}
